import { defineMessages } from "react-intl";

export default defineMessages({
  or: {
    id: "globals.or",
    defaultMessage: "or",
  },
});
